import { render, staticRenderFns } from "./ExamCreate.vue?vue&type=template&id=f3c320fe&scoped=true&"
import script from "./ExamCreate.vue?vue&type=script&lang=js&"
export * from "./ExamCreate.vue?vue&type=script&lang=js&"
import style0 from "./ExamCreate.vue?vue&type=style&index=0&id=f3c320fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c320fe",
  null
  
)

export default component.exports